import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

//import { SearchResultsComponent } from './search-results/search-results.component';
import { BuySearchComponent } from './components/buy-search/buy-search.component';
import { BuyComponent } from './buy.component';
import { BuyCarDetailsComponent } from './components/buy-car-details/buy-car-details.component';
import { HomeComponent } from '../home/home.component';

const routes: Routes = [
  {
    path: '', component: BuyComponent,
    children: [
      { path: '', component: HomeComponent   },
      { path: 'search', component: BuySearchComponent  },
      { path: 'details', component: BuyCarDetailsComponent  },
    
      //{ path: '', component: SearchComponent },
      //{ path: 'about', component: AboutComponent },
      //{ path: 'services', component: ServicesComponent },
      //{ path: 'contact', component: ContactComponent },
      //{ path: '', redirectTo: '/buy-car/search', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BuyRoutingModule { }
